// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__noxKv","header":"Menu_header__AiW66","logoContainer":"Menu_logoContainer__GwrbG","bottomBlock":"Menu_bottomBlock__QM_gT","profileInfo":"Menu_profileInfo__3KsP4"};